import React, { FC } from "react";
import { useFela } from "react-fela";
import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import Image from "next/image";
import { Button } from "@/components/Button";
import { Icon } from "@/components/Icon";

const BACKUP_PLUGIN_URL =
  "https://www.figma.com/community/plugin/1169407128424809563/Magicul-Backup-Plugin";

const FigmaBackupPlugin: FC = () => {
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <Grid
      wrapperStyle={{
        margin: "-100px 0 0 0",
      }}
    >
      <div
        className={css({
          display: "flex",
          background: "#1B0068",
          width: "100%",
          padding: "30px 50px",
          borderRadius: 22,
          alignItems: "center",
          flexDirection: "column",
          gap: 50,
          [bp.FROM_TABLET]: {
            padding: "50px 88px",
            flexDirection: "row",
          },
        })}
      >
        <div className={css({ [bp.FROM_TABLET]: { flex: "0 0 60%" } })}>
          <Heading as="h2" customStyle={{ color: "white" }}>
            Backup directly using our Figma plugin
          </Heading>
          <p
            className={css({
              color: "white",
              marginBottom: 30,
              lineHeight: "24px",
            })}
          >
            Use our Figma plugin to directly add new designs to your automated
            backups. Head over to the Figma Plugin Store and check it out. The
            backup plugin even allows you to see all backups across your entire
            team.
          </p>
          <Button
            onClick={() => window.open(BACKUP_PLUGIN_URL, "_blank")}
            customStyle={{
              width: "auto",
              padding: "10px 24px",
              display: "flex",
              gap: 12,
            }}
          >
            <span>Get the plugin</span>
            <Icon iconType="EXTERNAL" />
          </Button>
        </div>
        <div
          className={css({
            [bp.FROM_TABLET]: { flex: "0 0 40%", position: "relative" },
          })}
        >
          <div
            className={css({
              position: "absolute",
              top: "50%",
              right: -50,
              transform: "translateY(-50%)",
            })}
          >
            <svg
              width="412"
              height="412"
              viewBox="0 0 412 412"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_f_8454_118046)">
                <circle cx="206" cy="206" r="130" fill="#6D3CEA" />
              </g>
              <defs>
                <filter
                  id="filter0_f_8454_118046"
                  x="0"
                  y="0"
                  width="412"
                  height="412"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="38"
                    result="effect1_foregroundBlur_8454_118046"
                  />
                </filter>
              </defs>
            </svg>
          </div>

          <Image
            src="/images/figma-backup-plugin.png"
            width={394}
            height={376}
          />
        </div>
      </div>
    </Grid>
  );
};

export default FigmaBackupPlugin;
